export default __webpack_public_path__ + "static/media/fire_fox_scr.0b2fda28.png";